<template>
  <div class="home">
    <top />
    <centers />
    <bottom />
  </div>
</template>

<script>
import top from './components/top'
import centers from './components/center'
import bottom from './components/bottom'

export default {
  components: {
    top,
    centers,
    bottom
  }
}
</script>

<style scoped>
.home {
  padding-bottom: 100px;
  background-color: #f5f7fa;
}
</style>
